var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-result',{attrs:{"status":"warning","title":_vm.$t('message.noPermissionPage.title')},scopedSlots:_vm._u([{key:"extra",fn:function(){return undefined},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }